/**
 * 创作分发—通知公告
 * Bai.Zhiming
 * 2019-06-27
 *
 */
angular.module('iwoNoticeModule').controller('iwoNoticeManageCtrl', [
    '$scope',
    'trsHttpService',
    '$q',
    'modalDialog',
    '$state',
    'trsspliceString',
    '$sessionStorage',
    'iwoNoticeService',
    function($scope, trsHttpService, $q, modalDialog, $state, trsspliceString, $sessionStorage, iwoNoticeService) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.data = {
                items: [], // 公告列表
                selectedArray: [], // 已选
                keyWords: '', // 关键字
                typeid: '', // 类型id
                fromdate: '', // 发布日期筛选-开始日期
                untildate: '', // 发布日期筛选-结束日期
                status: '', // 状态
                typeArray: [{ name: '全部类型', value: -1 }],
                statusArray: [
                    { name: '全部状态', value: -1 },
                    { name: '待发布', value: 0 },
                    { name: '已发布', value: 1 },
                ],
            };

            /**
             * [page description:分页信息]
             */
            $scope.hotLists = {
                page: {
                    pn: 1, // 当前页
                    PAGESIZE: 20, // globleParamsSet.getPageSize(),
                    ITEMCOUNT: 0, // 总共多少数据
                    startpage: 0,
                },
                status: {
                    jumpToPageNum: 1,
                    startpage: 0,
                },
            };

            $scope.rights = [];
        }

        /**
         * [getData 获取列表数据]
         *
         * @param   {[type]}  page  [page description]
         *
         * @return  {[type]}        [return description]
         */
        function getData(page) {
            $scope.data.items = [];
            let defer = $q.defer();
            let params = {
                pageNumber: $scope.hotLists.page.pn,
                pageSize: $scope.hotLists.page.PAGESIZE,
            };
            if ($scope.data.keyWords) {
                params.keyWords = $scope.data.keyWords;
            }
            if ($scope.data.typeid.value != -1) {
                params.typeid = $scope.data.typeid.value;
            }
            if ($scope.data.status.value != -1) {
                params.status = $scope.data.status.value;
            }
            if ($scope.data.fromdate) {
                params.startTime = $scope.data.fromdate;
            }
            if ($scope.data.untildate) {
                params.endTime = $scope.data.untildate;
            }
            $scope.loadingPromise = iwoNoticeService.getNoticeList(params).then((data) => {
                if (data.issuccess == 'false') {
                    modalDialog.alertType('', data.msg, 'error', false);
                    defer.reject();
                } else {
                    $scope.data.items = data.data.content;
                    $scope.hotLists.page.ITEMCOUNT = data.data.totalElements;
                    $scope.hotLists.page.pn = ++data.data.number;
                    $scope.hotLists.page.PAGECOUNT = data.data.totalPages;
                    getReadNotices();
                    defer.resolve();
                }
            });
            return defer.promise;
        }

        /**
         * [initData description] 数据初始化
         * @return {[type]} [description]
         */
        function initData() {
            $scope.data.status = $scope.data.statusArray[0];
            getNoticeType();
            getData();
            getRights();
        }

        /**
         * [getRights 获取权限]
         *
         * @return  {[type]}  [return description]
         */
        function getRights() {
            iwoNoticeService.getNoticeRights().then((data) => {
                if (data && data.length) {
                    data.forEach((item) => {
                        $scope.rights[item.OPERNAME] = true;
                    });
                }
            });
        }

        /**
         * [getNoticeType 获取公告类型列表]
         *
         * @return  {[type]}  [return description]
         */
        function getNoticeType() {
            $scope.data.typeid = $scope.data.typeArray[0];
            let defer = $q.defer();
            let params = {
                serviceid: 'noticetype',
                method: 'noticetypeForDetail',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then(function(data) {
                if (data.issuccess == 'false') {
                    modalDialog.alertType('', data.msg, 'error', false);
                    defer.reject();
                } else {
                    $scope.data.typeArray = $scope.data.typeArray.concat(data.data.map((_item) => ({ name: _item.typename, value: _item.typeid })));
                    defer.resolve();
                }
            });
            return defer.promise;
        }

        /**
         * [requestData 改变条件，请求数据]
         *
         * @param   {[type]}  ev  [ev description]
         *
         * @return  {[type]}      [return description]
         */
        $scope.requestData = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                getData();
            }
        };

        /**
         * [pageChanged description]分页请求
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.hotLists.status.jumpToPageNum = $scope.hotLists.page.pn;
            $scope.hotLists.page.startpage = $scope.hotLists.page.pn - 1;
            getData();
            $scope.data.selectedArray = [];
        };

        /**
         * [jumpToPage description] 跳转分页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.hotLists.status.jumpToPageNum > $scope.hotLists.page.PAGECOUNT) {
                $scope.hotLists.status.jumpToPageNum = $scope.hotLists.page.PAGECOUNT;
            }
            if ($scope.hotLists.status.jumpToPageNum === '0' || isNaN(Number($scope.hotLists.status.jumpToPageNum))) {
                modalDialog.alertType('请输入合法的页码', '', 'warning', false);
                return;
            }
            $scope.hotLists.page.startpage = $scope.hotLists.status.jumpToPageNum - 1;
            getData();
            $scope.data.selectedArray = [];
        };

        /**
         * [checkSelect 判断是否选中]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.checkSelect = function(item) {
            return $scope.data.selectedArray.some((_item) => _item.noticeid == item.noticeid);
        };

        /**
         * [selectCheckAdd description] 选中/取消选中元素
         * @param  {[type]} item [description] 元素
         * @return {[type]}      [description]
         */
        $scope.selectCheckAdd = function(item) {
            if ($scope.checkSelect(item)) {
                $scope.data.selectedArray = $scope.data.selectedArray.filter((_item) => _item.noticeid != item.noticeid);
            } else {
                $scope.data.selectedArray.push(item);
            }
        };

        /**
         * [selectAll description] 全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.data.selectedArray.length == $scope.data.items.length && $scope.data.items.length > 0) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [].concat($scope.data.items);
            }
        };

        /**
         * [release 发布]
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.release = function(item) {
            let defer = $q.defer();
            modalDialog.confirmModal('', angular.isDefined(item) ? '确定发布该公告？' : '确认发布选中的公告', function() {
                let params = {
                    noticeids: angular.isDefined(item) ? item.noticeid : trsspliceString.spliceString($scope.data.selectedArray, 'noticeid', ','),
                };
                $scope.loadingPromise = iwoNoticeService.publish(params).then(function(data) {
                    if (data.issuccess == 'true') {
                        modalDialog.alertType('', '发布成功', 'success', false);
                        $scope.data.selectedArray = [];
                    } else if (data.msg == null) {
                        let report = data.data.map((_item) => ({
                            TITLE: _item.issuccess == 'true' ? '发布成功' : '发布失败',
                            DETAIL: _item.msg,
                            ISSUCCESS: _item.issuccess,
                        }));
                        modalDialog.multiReportsAlert({ TITLE: '发布结果', ISSUCCESS: false, REPORTS: report });
                    } else {
                        modalDialog.alertType('', data.msg, 'error', false);
                    }
                    defer.resolve();
                    getData();
                });
            });
            return defer.promise;
        };

        /**
         * [createOrEdit description] 新建/编辑公告
         * @param  {[type]} item [description] 公告
         * @return {[type]}      [description]
         */
        $scope.createOrEdit = function(item) {
            $state.go('front.editctr.iWo.notice.create', angular.isDefined(item) ? { noticeid: item.noticeid, status: item.status } : {});
        };

        /**
         * [getReadNotices 获取阅读状态]
         *
         * @return  {[type]}  [return description]
         */
        function getReadNotices() {
            let defer = $q.defer();
            if ($scope.data.items.length == 0) {
                return;
            }
            var noticeIds = trsspliceString.spliceString($scope.data.items, 'noticeid', ',');
            let params = {
                serviceid: 'notice',
                method: 'getReadStatus',
                noticeIds: noticeIds,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then(function(data) {
                comparisonArr(data.data);
                defer.resolve();
            });
        }

        /**
         * [comparisonArr description]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function comparisonArr(data) {
            $scope.data.items.forEach((item) => {
                for (var key in data) {
                    if (key == item.noticeid) {
                        item.readStatus = String(data[key].read) + '/' + String(data[key].total);
                    }
                }
            });
        }
        $scope.delate = function(item) {
            let info = '';
            if (item) {
                info = item.status === 1 ? '删除后用户将无法查看此通知，是否确定删除?' : '是否确定删除此通知?';
            }
            let params = {
                serviceid: 'notice',
                method: 'deleteNotice',
                noticeids: item ? item.noticeid : trsspliceString.spliceString($scope.data.selectedArray, 'noticeid', ','),
                userid: $sessionStorage.get('curUserInfo').ID,
            };
            modalDialog.confirmModal('删除', angular.isDefined(item) ? info : '确认删除选中的公告?', function() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'post').then((data) => {
                    if (data.issuccess === 'true') {
                        modalDialog.alertType('', '删除成功', 'success', false);
                        $scope.data.selectedArray = [];
                    } else if (data.msg === null) {
                        let report = data.data.map((_item) => ({
                            TITLE: _item.issuccess === 'true' ? '删除成功' : '删除失败',
                            DETAIL: _item.msg,
                            ISSUCCESS: _item.issuccess,
                        }));
                        modalDialog.multiReportsAlert({ TITLE: '删除结果', ISSUCCESS: false, REPORTS: report });
                    } else {
                        modalDialog.alertType('', data.msg, 'error', false);
                    }
                    getData();
                });
            });
        };

        $scope.groupManage = function() {
            iwoNoticeService.groupManage();
        };

        /**
         * [openNewCreate description]新建或者编辑一个公告
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.openNewCreate = function(item) {
            $scope.loadingPromise = iwoNoticeService.openNewCreate(item, $scope.rights['iwo.notice.publish']).then(() => {
                $scope.hotLists.page.pn = 1;
                $scope.hotLists.status.jumpToPageNum = $scope.hotLists.page.pn;
                $scope.hotLists.page.startpage = $scope.hotLists.page.pn - 1;
                getData();
            });
        };

        /**
         * [openPreview description]点击标题打开一个详情页弹框
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.openPreview = function(item) {
            $scope.loadingPromise = iwoNoticeService.openPreview(item, true);
        };
    },
]);
